import * as gfunctions from '../../../js/generalFunctions';

CCL.cheersConflictModal = {
  autoload: [
    ['modalEvents', $('#cheersConflictModal').length > 0]
  ],

  modalEvents() {
    const modalEl = $('#cheersConflictModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-cheers-conflict-modal/cheers-conflict-modal.js